import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './AIToggle/index.module.scss';

const ARTICLE_URL =
  'https://support.gelato.com/en/articles/8996353-non-automated-email-workflow-for-product-personalization';

// Description + learn more link shared between the standalone card below and the
// email workflow radio option in AIToggle.
export function EmailWorkflowPersonalizationContent() {
  const { t } = useTranslation();

  return (
    <div>
      <div className={cn(styles.content)}>{t('Email workflow personalization toggle-on content')}</div>
      <a className={cn(styles.learnMoreLink)} href={ARTICLE_URL} target="_blank" rel="noreferrer">
        {t('Learn more')}
      </a>
    </div>
  );
}

// Standalone title + description card shown when email workflow is the only available
// personalization option (no radio choice to make).
function EmailWorkflowPersonalizationOption() {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.AIToggle, 'mb-2', 'p-2', 'cy-personalization-single-option')}>
      <div className={styles.label}>{t('Email workflow personalization')}</div>
      <EmailWorkflowPersonalizationContent />
    </div>
  );
}

export default React.memo(EmailWorkflowPersonalizationOption);
